import { http } from '../http-common';

export interface AiCreditSettings {
  available: boolean;
  unitPrice: number | null;
  model: 'GPT_5_6_SOL' | 'GPT_5_6_TERRA' | 'GPT_5_6_LUNA';
  serviceTier: 'DEFAULT' | 'PRIORITY' | 'FLEX';
  reasoningEffort: 'NONE' | 'LOW' | 'MEDIUM' | 'HIGH' | 'XHIGH' | 'MAX';
}

export interface AiPromptSettings {
  chatSystemMessage: string;
  studentReportSystemMessage: string;
  weeklyActivityReportSystemMessage: string;
}

export interface AiCreditSale {
  id: number;
  studentId: number;
  studentName: string;
  studentEmail: string;
  creditAmount: number;
  unitPrice: number;
  totalAmount: number;
  status: 'PENDING' | 'COMPLETED' | 'FAILED';
  paymentTransactionId: string;
  reconcilable: boolean;
  createdAt: string;
  completedAt?: string | null;
}

export interface AiCreditSalesPage {
  content: AiCreditSale[];
  totalElements: number;
  totalPages: number;
  number: number;
  size: number;
}

const getSettings = () => http.get<AiCreditSettings>('/admin/ai-credit/settings');

const updateSettings = (settings: AiCreditSettings) =>
  http.put<AiCreditSettings>('/admin/ai-credit/settings', settings);

const getPrompts = () => http.get<AiPromptSettings>('/admin/ai-credit/prompts');

const updatePrompts = (settings: AiPromptSettings) =>
  http.put<AiPromptSettings>('/admin/ai-credit/prompts', settings);

const getSales = (page = 0, size = 20) =>
  http.get<AiCreditSalesPage>('/admin/ai-credit/purchases', { params: { page, size } });

const reconcileSale = (purchaseId: number) =>
  http.post(`/admin/ai-credit/purchases/${purchaseId}/reconcile`);

const AiCreditService = { getSettings, updateSettings, getPrompts, updatePrompts, getSales, reconcileSale };

export default AiCreditService;
